import { createStore } from '@stencil/store';
// Read more about how stencil stores work here: https://stenciljs.com/docs/stencil-store

const { state, onChange } = createStore({
  openLevel: '',
  openMenu: false,
  i18n: {
    open: '',
    close: '',
    navLabel: '',
  },
});

export { state, onChange };
export default state;
